export default (email = ''): boolean => /^[^@\s]+@[^@\s]{2,}\.[^@\s]{2,}$/.test(email.trim())
